import { render, staticRenderFns } from "./LidasNotificacoes.vue?vue&type=template&id=a4e47ad6"
import script from "./LidasNotificacoes.vue?vue&type=script&lang=js"
export * from "./LidasNotificacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports